@if (view$ | async; as view) {
  <div class="usage-bar">
    <app-ai-month-stepper [label]="view.monthLabel" [canStepForward]="view.canStepForward" (step)="stepMonth($event)">
    </app-ai-month-stepper>
    <div class="grouping-switch">
      @for (option of groupings; track trackByIndex($index)) {
        <button type="button" class="grouping-btn" [class.active]="view.groupBy === option.value"
          (click)="setGroupBy(option.value)">{{ option.label | translate }}</button>
      }
    </div>
    @if (totals$ | async; as totals) {
      <div class="kpi-line">
        <span><b>{{ totals.creditsUsed | number:'1.2-2' }}</b> {{ 'credits' | translate }}</span>
        <i class="kpi-divider"></i>
        <span><b>{{ totals.activeUserCount }}</b> {{ 'active users' | translate }}</span>
        <i class="kpi-divider"></i>
        <span><b>{{ totals.questionCount }}</b> {{ 'questions' | translate }}</span>
        <i class="kpi-divider"></i>
        <span><b>{{ totals.reportCount }}</b> {{ 'reports' | translate }}</span>
      </div>
    }
  </div>
}
